import React, { Component } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Button from "@material-ui/core/Button";
import FetchServerData from "../../../provider/FetchServerData";
import Multiselect from "multiselect-react-dropdown";
import createDOMPurify from "dompurify";
// import PtsAlert from "../ptsAlert/PtsAlert";
import { SendWidgetMsgToPhone_Url } from "../../../provider/ServiceUrl";
import Utils from "../../../provider/Utils";
import defaultWidget_logo from "../../../assets/img/defaultWidget_logo.jpg";
import "./WidgetTemplate.css";
class WidgetPreview extends Component {
  constructor(props) {
    super(props);
    const str = new URLSearchParams(window.location.search);
    const urlTid = str.get("t");
    const widgetId = str.get("w");

    this.state = {
      urlTid: urlTid,
      widgetId: widgetId,
      firstName: "",
      lastName: "",
      email: "",
      mobileNo: "",
      mobile: "",
      message: "",
      tandcUrl: "",
      privacyPolicyUrl: "",
      countryCode: "+1",
      smsGroup: null,
      ogrName: null,
      orgLogo: null,
      smsGroupList: [],
      groupList: [],
      isFirstName: false,
      isLastName: false,
      isEmail: false,
      isFirstNameRequired: false,
      isLastNameRequired: false,
      isEmailRequired: false,
      acceptTermsAndCondition: false,
      autoFocus: false,
      render: false,
    };
    this.getWidgetDetails(urlTid, widgetId);
    this.mobileInputRef = React.createRef();
  }

  getWidgetDetails(urlTid, widgetId) {
    const postObject = {
      header: { tid: urlTid },
      widgetTemplate: {
        id: widgetId,
      },
    };
    FetchServerData.callPostService("/smsWidgetTemplatems/get", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let widgetTemplate = output.data.widgetTemplate;
          let smsGroupList = [];
          for (
            let k = 0;
            k < widgetTemplate?.widgetTemplateGroups?.length;
            k++
          ) {
            const element = widgetTemplate?.widgetTemplateGroups[k]?.smsGroup;

            if (element !== null && element !== undefined) {
              smsGroupList.push(element);
            }
          }

          const imageSrc =
            widgetTemplate?.isOrglogoAsWidgetLogo && widgetTemplate?.orgLogo
              ? widgetTemplate.orgLogo
              : widgetTemplate?.bannerImage
                ? "data:image/png;base64," + widgetTemplate.bannerImage
                : null

          this.setState({
            render: true,
            action: "view",
            widgetId: widgetTemplate.id,
            message: widgetTemplate.title,
            isFirstName: widgetTemplate.isFirstName,
            isLastName: widgetTemplate.isLastName,
            isEmail: widgetTemplate.isEmail,
            isFirstNameRequired: widgetTemplate.isFirstNameRequired,
            isLastNameRequired: widgetTemplate.isLastNameRequired,
            isEmailRequired: widgetTemplate.isEmailRequired,
            url: widgetTemplate.url,
            iframeCode: widgetTemplate.iframeCode,
            smsGroupList: smsGroupList,
            privacyPolicyUrl: widgetTemplate.privacyPolicyUrl,
            tandcUrl: widgetTemplate.tandcUrl,
            ogrName: widgetTemplate.ogrName,
            isOrglogoAsWidgetLogo: widgetTemplate.isOrglogoAsWidgetLogo,
            orgLogo: imageSrc,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  sendWidgetTemplateToBackend() {
    let widgetTemplateGroups = [];
    for (let i = 0; i < this.state.groupList.length; i++) {
      widgetTemplateGroups.push(this.state.groupList[i].id);
    }
    const postObject = {
      header: { tid: this.state.urlTid },
      widgetTemplate: {
        id: this.state.widgetId,
      },
      countryCode: this.state.countryCode,
      phoneNumber: this.state.mobile,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      email: this.state.email,
      groupList: widgetTemplateGroups,
    };
    FetchServerData.callPostService(SendWidgetMsgToPhone_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          // PtsAlert.success(output.message);
          this.setState({
            action: "sendSMSSuccessfully",
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  handleFirstNameChange(e) {
    this.setState({ firstName: e.target.value });
  }
  handleLastNameChange(e) {
    this.setState({ lastName: e.target.value });
  }
  handleEmailChange(e) {
    this.setState({ email: e.target.value });
  }

  handleMobileNoChange(e) {
    let val = e.target.value;
    if (val.length <= 12) {
      let value = Utils.phoneNumberFormate(val);
      this.setState({
        mobileNo: value,
        mobile: e.target.value.replace(/-/g, ""),
      });
    }
  }
  onSelectGroups(selectedList, selectedItem) {
    this.setState({
      groupList: selectedList,
      smsGroup: selectedItem,
    });
  }

  onRemoveGroups(selectedList, selectedItem) {
    this.setState({
      groupList: selectedList,
    });
  }

  handleCountryChange(phone, country, e, formattedValue) {
    this.setState({
      countryCode: formattedValue,
      autoFocus: true,
    });
    if (this.mobileInputRef.current) {
      this.mobileInputRef.current.focus();
    }
  }

  handleAcceptTermsAndConditionChange() {
    this.setState({
      acceptTermsAndCondition: !this.state.acceptTermsAndCondition,
    });
  }
  handleRefreshWidget() {
    this.setState({
      action: "view",
      firstName: "",
      lastName: "",
      email: "",
      mobileNo: "",
      countryCode: "+1",
      mobile: "",
      groupList: [],
      acceptTermsAndCondition: false,
      render: true,
    });
  }
  render() {
    if (this.state.action === "sendSMSSuccessfully") {
      return this.sendSMSSuccessfullyMessageShow();
    } else {
      return this.WidgetPreview();
    }
  }

  WidgetPreview() {
    const DOMPurify = createDOMPurify(window);
    const enableCountryCode = process.env.REACT_APP_ENABLE_COUNTRYCODE === "true";

    if (this.state.render === false) {
      return <div />;
    }
    return (
      <div
        className="container-fluid"
        style={{
          backgroundColor: "#ffff",
          minHeight: "100vh",
        }}
      >
        <div className="row p-4">
          <div className="col-md-3">
            <div className="row" style={{ width: "300px" }}>
              <div className="col-md-12">
                <ValidatorForm
                  className="text-start"
                  ref="form"
                  // style={{ width: "250px" }}
                  onSubmit={this.sendWidgetTemplateToBackend.bind(this)}
                >
                  {this.state.orgLogo !== null && (
                    <div className="row">
                      <div className="col-md-12" id="assetFormLabel">
                        <div
                          style={{
                            display: "inline-flex",
                          }}
                        >
                          <a href="http://localhost:3000/" target="_blank">
                            <img
                              src={this.state.orgLogo}
                              style={{
                                width: "274px",
                                height: "100px",
                                objectFit: "contain",
                                objectPosition: "center",
                              }}
                              alt="logo"
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  )
                  }
                  <div
                    className="row justify-content-center"
                  // style={{ textAlign: "center" }}
                  >
                    <div className="col-md-12 mt-2 pe-0" id="widgetTextEditor">
                      {
                        <div
                          className="se-wrapper-inner se-wrapper-wysiwyg sun-editor-editable"
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(this.state.message || ""),
                          }}
                        />
                      }
                    </div>
                    <div className="col-md-12 mt-2">
                      {this.state.isFirstName && (
                        <div className="col-md-12 mt-1" id="assetFormLabel">
                          {this.state.isFirstNameRequired ? (
                            <input
                              title=""
                              required
                              type="text"
                              autoComplete="off"
                              id="multiStepsFirstName"
                              name="multiStepsFirstName"
                              className="widget-form-control form-control"
                              placeholder="First Name"
                              value={this.state.firstName}
                              onChange={this.handleFirstNameChange.bind(this)}
                              validators={["required"]}
                              errormessages={["This field is required"]}
                            />
                          ) : (
                            <input
                              type="text"
                              autoComplete="off"
                              id="multiStepsFirstName"
                              name="multiStepsFirstName"
                              className="widget-form-control form-control"
                              placeholder="First Name"
                              value={this.state.firstName}
                              onChange={this.handleFirstNameChange.bind(this)}
                              validators={["required"]}
                              errormessages={["This field is required"]}
                            />
                          )}
                        </div>
                      )}
                      {this.state.isLastName && (
                        <div className="col-md-12 mt-1" id="assetFormLabel">
                          {this.state.isLastNameRequired ? (
                            <input
                              title=""
                              required
                              type="text"
                              autoComplete="off"
                              id="multiStepsFirstName"
                              name="multiStepsFirstName"
                              className="widget-form-control form-control"
                              placeholder="Last Name"
                              value={this.state.lastName}
                              onChange={this.handleLastNameChange.bind(this)}
                              validators={["required"]}
                              errormessages={["This field is required"]}
                            />
                          ) : (
                            <input
                              type="text"
                              autoComplete="off"
                              id="multiStepsFirstName"
                              name="multiStepsFirstName"
                              className="widget-form-control form-control"
                              placeholder="Last Name"
                              value={this.state.lastName}
                              onChange={this.handleLastNameChange.bind(this)}
                              validators={["required"]}
                              errormessages={["This field is required"]}
                            />
                          )}
                        </div>
                      )}
                      <div className="col-sm-12 mt-1" id="assetFormLabel">
                        {enableCountryCode ?
                          <span className="WidgetPhoneInput">
                            <PhoneInput
                              country={"us"}
                              className="phoneInput"
                              onlyCountries={["us", "ca", "au", "in"]}
                              value={this.state.countryCode}
                              onChange={(phone, country, e, formattedValue) => {
                                this.handleCountryChange(
                                  phone,
                                  country,
                                  e,
                                  formattedValue
                                );
                              }}
                              autoFormat
                              countryCodeEditable={false}
                              disableCountryGuess={false}
                              enableSearch={true}
                              alwaysDefaultMask={true}
                            />
                            <input
                              ref={this.mobileInputRef}
                              title=""
                              required
                              autoFocus={this.state.autoFocus}
                              style={{ borderRadius: "0px 5px 5px 0px" }}
                              type="text"
                              autoComplete="off"
                              id="multiStepsFirstName"
                              name="multiStepsFirstName"
                              className="widget-form-control form-control"
                              placeholder="Mobile No."
                              value={this.state.mobileNo}
                              onChange={this.handleMobileNoChange.bind(this)}
                              validators={["required"]}
                              errormessages={["This field is required"]}
                            />
                          </span>
                          : <input
                            ref={this.mobileInputRef}
                            title=""
                            required
                            autoFocus={this.state.autoFocus}
                            type="text"
                            autoComplete="off"
                            id="multiStepsFirstName"
                            name="multiStepsFirstName"
                            className="widget-form-control form-control"
                            placeholder="Mobile No."
                            value={this.state.mobileNo}
                            onChange={this.handleMobileNoChange.bind(this)}
                            validators={["required"]}
                            errormessages={["This field is required"]}
                          />
                        }
                      </div>
                      {this.state.isEmail && (
                        <div className="col-md-12 mt-1" id="assetFormLabel">
                          {this.state.isEmailRequired ? (
                            <input
                              title=""
                              required
                              type="email"
                              autoComplete="off"
                              id="multiStepsFirstName"
                              name="multiStepsFirstName"
                              className="widget-form-control form-control"
                              placeholder="Email"
                              value={this.state.email}
                              onChange={this.handleEmailChange.bind(this)}
                              validators={["required"]}
                              errormessages={["This field is required"]}
                            />
                          ) : (
                            <input
                              type="email"
                              autoComplete="off"
                              id="multiStepsFirstName"
                              name="multiStepsFirstName"
                              className="widget-form-control form-control"
                              placeholder="Email"
                              value={this.state.email}
                              onChange={this.handleEmailChange.bind(this)}
                              validators={["required"]}
                              errormessages={["This field is required"]}
                            />
                          )}
                        </div>
                      )}
                      {this.state.smsGroupList.length > 0 && (
                        <div
                          className="col-md-12 mt-1 widget"
                          id="assetFormLabel"
                        >
                          <Multiselect
                            className="custom-multiselect"
                            onRemove={this.onRemoveGroups.bind(this)}
                            onSelect={this.onSelectGroups.bind(this)}
                            options={this.state.smsGroupList}
                            displayValue="name"
                            showCheckbox
                            placeholder={
                              this.state.groupList.length === 0
                                ? "Join Text Group"
                                : this.state.groupList.length > 1
                                  ? `${this.state.groupList.length} groups selected`
                                  : `${this.state.groupList.length} group selected`
                            }
                            hideSelectedList={true}
                            showArrow={true}
                          />
                        </div>
                      )}
                      <div className="d-flex mt-2">
                        <div
                          className="col-1 col-sm-1 d-flex align-self-start pe-0"
                        // style={{ width: "30px" }}
                        >
                          <input
                            type="checkbox"
                            style={{
                              transform: "scale(1.2)",
                              cursor: "pointer",
                              marginTop: "2px",
                            }}
                            checked={this.state.acceptTermsAndCondition}
                            onChange={(e) =>
                              this.handleAcceptTermsAndConditionChange(e)
                            }
                          />
                        </div>
                        <div className="col-11 col-sm-11 p-0">
                          <p
                            style={{
                              color: "#353538",
                              fontSize: "11px",
                              // textAlign: "justify",
                              lineHeight: "15px",
                            }}
                          >
                            <span
                              className="cursor-pointer"
                              onClick={(e) =>
                                this.handleAcceptTermsAndConditionChange(e)
                              }
                            >
                              By submitting form, I agree to receive SMS texts
                              from {this.state.ogrName}.<br></br> Msg&Data rates
                              apply. Frqcy varies. STOP to quit. HELP for help.
                              Consent to receive texts is not a condition of any
                              service we provide.
                            </span>
                            <br></br>
                            <span>
                              <a
                                href={
                                  this.state.tandcUrl.includes("https://") ||
                                    this.state.tandcUrl.includes("http://")
                                    ? this.state.tandcUrl
                                    : "http://" + this.state.tandcUrl
                                }
                                className="footer-link me-2"
                                target="_blank"
                                rel="noreferrer"
                              // style={{ color: "#fff" }}
                              >
                                Terms &amp; Conditions
                              </a>
                              <a
                                href={
                                  this.state.privacyPolicyUrl.includes("https://") ||
                                    this.state.privacyPolicyUrl.includes("http://")
                                    ? this.state.privacyPolicyUrl
                                    : "http://" + this.state.privacyPolicyUrl
                                }
                                target="_blank"
                                rel="noreferrer"
                                className="footer-link"
                              // style={{ color: "#fff" }}
                              >
                                | &nbsp;Privacy Policy
                              </a>
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="row text-center justify-content-center">
                        <div className="col-md-12">
                          {this.state.acceptTermsAndCondition ? (
                            <Button
                              type="submit"
                              className="me-2"
                              style={{
                                padding: "2px 10px",
                                background: "#337ab7",
                                color: "#fff",
                                fontSize: "14px",
                                fontWeight: "600",
                                width: "100%",
                                textTransform: "capitalize",
                              }}
                            >
                              Send
                            </Button>
                          ) : (
                            <Button
                              disabled
                              className="me-2"
                              type="submit"
                              style={{
                                padding: "2px 10px",
                                background: "#99BCDB",
                                color: "#fff",
                                fontSize: "14px",
                                fontWeight: "600",
                                width: "100%",
                                textTransform: "capitalize",
                              }}
                            >
                              Send
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </ValidatorForm>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  sendSMSSuccessfullyMessageShow() {
    return (
      <div
        className="container-fluid"
        style={{
          backgroundColor: "#ffff",
          minHeight: "100vh",
        }}
      >
        <div className="row p-4">
          <div className="col-md-3">
            <div className="row" style={{ width: "300px" }}>
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-12" id="assetFormLabel">
                    <div
                      style={{
                        display: "inline-flex",
                      }}
                    >
                      {this.state.orgLogo !== null && (
                        <a href="http://localhost:3000/" target="_blank">
                          <img
                            src={this.state.orgLogo}
                            style={{ width: "274px", height: "100px" }}
                            alt="logo"
                          />
                        </a>
                      )}
                    </div>
                  </div>
                  <div className="col-md-12 mt-4 text-center p-0" id="assetFormLabel">
                    <p style={{ color: "#353538", fontSize: "16px" }}>
                      Please check your phone. A text was sent.
                    </p>
                  </div>
                  <div className="col-md-12 mt-2 text-center" id="assetFormLabel">
                    <span
                      className="anchortag"
                      onClick={this.handleRefreshWidget.bind(this)}
                    >
                      <u>Refresh</u>
                    </span>
                  </div>
                </div>
                <div className="row mt-2 justify-content-end" style={{ paddingTop: "45px" }}>
                  <div className="col-md-12 text-center">
                    <span className="anchortag">Powered by GivBee</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default WidgetPreview;
